import React from 'react';
import Tooltip from './Tooltip';

/**
 * Shared slider component for scoring interfaces.
 * Renders a labeled range input with a value display.
 */
const ScoringSlider = ({ label, min, max, value, onChange, tooltip, disabled = false }) => {
    const handleChange = (e) => {
        if (!disabled) {
            onChange(Number(e.target.value));
        }
    };

    return (
        <div className={`slider-row${disabled ? ' disabled' : ''}`}>
            <label className="slider-label">
                {label}
                {tooltip && (
                    <Tooltip content={tooltip}>
                        <span className="tooltip-icon">i</span>
                    </Tooltip>
                )}
            </label>
            <div className="scoring-slider">
                <input
                    type="range"
                    min={min}
                    max={max}
                    value={value}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </div>
            <span className="slider-value">{value}</span>
        </div>
    );
};

export default ScoringSlider;

